import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';
import { Link } from 'react-router';
import CircularProgress from 'material-ui/CircularProgress';
import TextField from 'material-ui/TextField';
import {List, ListItem} from 'material-ui/List';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';
import PageLoading from '../components/PageLoading';
import Dialog from 'material-ui/Dialog';
import CustomerUserList from '../components/CustomerUserList';

export default
@observer class ImpersonatePage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  userSelected(id_customer, id_user ) {
    console.log("Let's impersonate "+id_customer+":"+id_user);
    AppModelUtils.impersonate(id_customer, id_user, this.context.router);
  }

  render() {
    return (
      <PageLoading loading={AppModel.customerListLoading
          || AppModel.fetchingImpersonateToken
      }>
        <CustomerUserList customers={AppModel.customerList}
                          userSelected = {this.userSelected.bind(this)} >
        </CustomerUserList>
      </PageLoading>
    );
  }

};

/*



  */



/** WEBPACK FOOTER **
 ** ./src/pages/ImpersonatePage.jsx
 **/